module.exports = __webpack_public_path__ + "static/media/Highway.2d571f85.png";